import React from 'react'
import { Outlet } from 'react-router-dom'

function Blank(): JSX.Element {
  return <Outlet />
}

export default Blank
